"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHub = void 0;
const ChatHub_Utils_js_1 = require("./ChatHub.Utils.js");
class ChatHub {
    set Connection(connection) {
        this.connection = connection;
    }
    get Connection() {
        return this.connection;
    }
    sendMessage(conversationId, message) {
        return this.Connection.invoke('SendMessage', conversationId, message);
    }
    deleteConversation(conversationId) {
        return this.Connection.invoke('DeleteConversation', conversationId);
    }
    markConversationAsRead(conversationId) {
        return this.Connection.invoke('MarkConversationAsRead', conversationId);
    }
    deleteMessage(conversationId, messageId) {
        return this.Connection.invoke('DeleteMessage', conversationId, messageId);
    }
    markAllMessagesAsRead() {
        return this.Connection.invoke('MarkAllMessagesAsRead');
    }
    getConversations(conversationUpdatedAt) {
        return this.Connection.invoke('GetConversations', conversationUpdatedAt);
    }
    getConversation(otherUserId) {
        return this.Connection.invoke('GetConversation', otherUserId);
    }
    getConversationMessages(conversationId, lastMessageTimestamp) {
        return this.Connection.invoke('GetConversationMessages', conversationId, lastMessageTimestamp);
    }
    subscribeToPresence(otherUserId) {
        return this.Connection.invoke('SubscribeToPresence', otherUserId);
    }
    unsubscribeFromPresence(otherUserId) {
        return this.Connection.invoke('UnsubscribeFromPresence', otherUserId);
    }
    addToGroup(groupId) {
        return this.Connection.invoke('AddToGroup', groupId);
    }
    removeFromGroup(groupId) {
        return this.Connection.invoke('RemoveFromGroup', groupId);
    }
    sendMessageToGroup(groupId, message) {
        return this.Connection.invoke('SendMessageToGroup', groupId, message);
    }
    conversationDeletedImplementationFn(implementation, conversationDeletedData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.conversationDeleted, conversationDeletedData);
    }
    messageDeletedImplementationFn(implementation, messageDeletedData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.messageDeleted, messageDeletedData);
    }
    markAllMessagesAsReadImplementationFn(implementation) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.markAllMessagesAsRead);
    }
    markConversationAsReadImplementationFn(implementation, markConversationAsReadData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.markConversationAsRead, markConversationAsReadData);
    }
    messageReceivedImplementationFn(implementation, messageReceivedData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.messageReceived, messageReceivedData);
    }
    presenceUpdateImplementationFn(implementation, presenceUpdateData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.presenceUpdate, presenceUpdateData);
    }
    groupInfoUpdatedImplementationFn(implementation, groupInfoUpdatedData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.groupInfoUpdated, groupInfoUpdatedData);
    }
    groupMessageReceivedImplementationFn(implementation, groupMessageReceivedData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.groupMessageReceived, groupMessageReceivedData);
    }
    systemMessageReceivedImplementationFn(implementation, systemMessageReceivedData) {
        ChatHub_Utils_js_1.ChatHubUtils.CallIfFunction(implementation.systemMessageReceived, systemMessageReceivedData);
    }
    registerCallbacks(implementation) {
        this.Connection.on('ConversationDeleted', this.conversationDeletedImplementationFn.bind(this, implementation));
        this.Connection.on('MessageDeleted', this.messageDeletedImplementationFn.bind(this, implementation));
        this.Connection.on('MarkAllMessagesAsRead', this.markAllMessagesAsReadImplementationFn.bind(this, implementation));
        this.Connection.on('MarkConversationAsRead', this.markConversationAsReadImplementationFn.bind(this, implementation));
        this.Connection.on('MessageReceived', this.messageReceivedImplementationFn.bind(this, implementation));
        this.Connection.on('PresenceUpdate', this.presenceUpdateImplementationFn.bind(this, implementation));
        this.Connection.on('GroupInfoUpdated', this.groupInfoUpdatedImplementationFn.bind(this, implementation));
        this.Connection.on('GroupMessageReceived', this.groupMessageReceivedImplementationFn.bind(this, implementation));
        this.Connection.on('SystemMessage', this.systemMessageReceivedImplementationFn.bind(this, implementation));
    }
    unregisterCallbacks(implementation) {
        this.Connection.off('ConversationDeleted', this.conversationDeletedImplementationFn.bind(this, implementation));
        this.Connection.off('MessageDeleted', this.messageDeletedImplementationFn.bind(this, implementation));
        this.Connection.off('MarkAllMessagesAsRead', this.markAllMessagesAsReadImplementationFn.bind(this, implementation));
        this.Connection.off('MarkConversationAsRead', this.markConversationAsReadImplementationFn.bind(this, implementation));
        this.Connection.off('MessageReceived', this.messageReceivedImplementationFn.bind(this, implementation));
        this.Connection.off('PresenceUpdate', this.presenceUpdateImplementationFn.bind(this, implementation));
        this.Connection.off('GroupInfoUpdated', this.groupInfoUpdatedImplementationFn.bind(this, implementation));
        this.Connection.off('GroupMessageReceived', this.groupMessageReceivedImplementationFn.bind(this, implementation));
        this.Connection.off('SystemMessage', this.systemMessageReceivedImplementationFn.bind(this, implementation));
    }
}
exports.ChatHub = ChatHub;
//# sourceMappingURL=ChatHub.js.map